import Image from 'next/image';
import { useState } from 'react';

interface ISearchImage {
  alt?: string;
  src?: string;
  errorImage?: string;
  placeholder?: any;
  quality?: number;
  className?: string;
  fill?: any;
  native?: boolean;
  width?: number;
  height?: number;
}

function SearchImage({
  alt,
  src,
  errorImage,
  placeholder,
  quality,
  className,
  fill,
  native = false,
  width,
  height,
}: ISearchImage) {
  const [newSrc, setNewSrc] = useState(src || errorImage);
  return !native ? (
    <Image
      src={newSrc}
      alt={alt} // To fix lint warning
      onError={() => {
        setNewSrc(errorImage);
      }}
      placeholder={placeholder}
      blurDataURL={errorImage}
      quality={quality}
      className={className}
      fill
      width={width}
      height={height}
    />
  ) : (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={`${newSrc}?q=${quality}`}
      alt={alt}
      className={className}
      onError={() => {
        setNewSrc(errorImage);
      }}
      width={width}
      height={height}
    />
  );
}

export default SearchImage;
